/**
 * Color ramps for the Display tab's Climate overlay (Map.ts's polygon fill
 * and ClimateLegend's gradient bar both import from here).
 *
 * Deliberately sequential (one hue, light -> dark), not the diverging
 * blue/yellow/red ramp marketTrendsColors.ts uses for price. Price has a
 * meaningful "distance from average" - more/less expensive than typical is
 * a real, evaluative axis, which is what a diverging ramp communicates.
 * Rainfall and temperature don't have that: more rain isn't a "worse" rain
 * the way a higher price is a worse price, it's just more of the same
 * quantity. A sequential ramp (low = light, high = dark) is the correct
 * encoding for a plain magnitude with no evaluative center.
 */
export const RAINFALL_RAMP = ['#eff6ff', '#bfdbfe', '#60a5fa', '#2563eb', '#1e3a8a'];
export const TEMPERATURE_RAMP = ['#fef9c3', '#fde68a', '#fb923c', '#ea580c', '#7c2d12'];
export const CLIMATE_RAMPS = {
    rainfall: RAINFALL_RAMP,
    temperature: TEMPERATURE_RAMP,
};
// Same neutral used for Market Trends' "not enough data" case - one shared
// meaning across every fill type: gray = no data, never part of any ramp.
export const CLIMATE_NO_DATA_COLOR = '#d1d5db';
/**
 * Piecewise, not linear min-to-max - same reasoning as
 * getMarketTrendsColor: real climate data is often right-skewed (a handful
 * of very wet windward valleys stretch `max` far past where most areas
 * actually sit), so the ramp's middle color is anchored to `center` (the
 * average of the values being colored) rather than the linear midpoint of
 * min/max, keeping the common case spread across the ramp instead of
 * crushed into its lightest end.
 */
export function getClimateColor(ramp, value, min, center, max) {
    if (max <= min)
        return ramp[ramp.length - 1];
    const clamped = Math.max(min, Math.min(max, value));
    let t;
    if (center <= min || center >= max) {
        t = (clamped - min) / (max - min);
    }
    else if (clamped <= center) {
        t = 0.5 * (clamped - min) / (center - min);
    }
    else {
        t = 0.5 + 0.5 * (clamped - center) / (max - center);
    }
    const index = Math.min(ramp.length - 1, Math.floor(t * ramp.length));
    return ramp[index];
}
//# sourceMappingURL=climateColors.js.map